/** Inbox integration of the Service Desk (CH-015, SD-S1-49): Convert to ticket, the ticket chip and Linked tickets. */
export const serviceInbox = {
  convert: {
    button: "Convert to ticket",
    title: "Convert to ticket",
    description: "Prefilled from the handoff summary. {{name}} gets the ticket number in the chat and by e-mail when you leave the box ticked.",
    descriptionNoNotify: "Prefilled from the handoff summary. {{name}} is not told until you reply.",
    descriptionLabel: "Description (AI summary)",
    descriptionHint: "You can edit it. The client sees the title, not the AI summary.",
    summaryNone: "No summary was written for this chat, so the description starts empty.",
    requester: "Requester",
    requesterFromChat: "Taken from the chat: {{name}}. Search to pick an existing contact instead.",
    notify: "Tell the client",
    notifyHint: "Sends the receipt with the ticket number. Turn off to keep it quiet.",
    keepOpen: "Keep the handoff open",
    keepOpenHint: "The chat stays with the team so you can keep replying. Turn off to resolve the chat now.",
    submit: "Create ticket",
    cancel: "Cancel",
    created: "Ticket {{number}} created from this chat.",
    createdResolved: "Ticket {{number}} created and the chat resolved.",
    resolveFailed: "Ticket {{number}} was created, but the chat could not be resolved. Resolve it from the status menu.",
    typesError: "We couldn't load the ticket types.",
    noTypes: "No ticket type can be raised from the inbox yet. Add one in Service settings.",
    unavailable: "Tickets aren't available for this workspace.",
  },
  chip: { open: "Open ticket {{number}}", label: "Ticket {{number}}" },
  linked: {
    title: "Linked tickets",
    none: "No ticket yet. Convert this chat when it needs follow-up.",
    open: "Open ticket {{number}}",
    error: "We couldn't load the linked tickets.",
    retry: "Try again",
  },
} as const;
